(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["byzio-trust"] && !Shopify.designMode) return;
  try {
    

function initBuyzioTrustSplide() {

  document.querySelectorAll('.buyzio-trust-splide').forEach(function (el) {

    if (el.dataset.splideInitialized === 'true') return;

    el.dataset.splideInitialized = 'true';

    new Splide(el, {
      perPage: 4,
      gap: '40px',
      drag: false,
      arrows: false,
      pagination: false,

      breakpoints: {
        768: {
          perPage: 1,
          gap: '0px',
          drag: true,
          pagination: true
        }
      }

    }).mount();

  });

}

if (window.Splide) {
  initBuyzioTrustSplide();
} else {
  window.addEventListener('splide:ready', initBuyzioTrustSplide, { once: true });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
